import { useSelector } from 'react-redux';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { PortalConfiguration, PortalConfigurationRenderProps } from 'modules/portalConfigurations/types';

import { DealerTiers } from './DealerTiers';
import { DealerTiersPortalConfiguration } from '../types';
import { dealerTiersPortalConfiguration } from '../constants';

export const DealerTiersCard = ({ onSaveConfiguration, loading }: PortalConfigurationRenderProps) => {
  const isTieredDealersEnabled = useSelector<any, boolean>(portalConfigurationsSelectors.isTieredDealersEnabled);

  const portalConfiguration = useSelector<any, PortalConfiguration<DealerTiersPortalConfiguration>>(state =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.DealerTiers)
  );

  if (!isTieredDealersEnabled) return null;

  const handleSave = async (formData: DealerTiersPortalConfiguration) => {
    const configToSave: PortalConfiguration<DealerTiersPortalConfiguration> = {
      ...portalConfiguration,
      jsonDefinition: { config: formData },
    };

    await onSaveConfiguration(configToSave);
  };

  return (
    <CardContainer title="Dealer Tiers">
      <DealerTiers
        isLoading={loading}
        onConfirm={handleSave}
        defaultValues={portalConfiguration?.jsonDefinition?.config ?? dealerTiersPortalConfiguration}
      />
    </CardContainer>
  );
};
